import { OrderRepository } from "../../../../data/repository/order/OrderRepository";
import { Order } from "../../../model/Order";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetAllOrdersUseCase {
  invoke: (
    skip?: number,
    limit?: number
  ) => Promise<ResponseState<Array<Order>>>;
}

export class GetAllOrdersUseCaseImpl implements GetAllOrdersUseCase {
  private repository: OrderRepository;

  constructor(repository: OrderRepository) {
    this.repository = repository;
  }

  async invoke(
    skip?: number,
    limit?: number
  ): Promise<ResponseState<Array<Order>>> {
    try {
      let response = await this.repository.getAll(skip, limit);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
